export const SUPPORTED_LOCALES = ['en', 'cs', 'de'];

const TRANSLATIONS = {
  en: {
    tabs: {
      overview: 'Overview',
      serviceHistory: 'Service history',
      documents: 'Documents',
      gallery: 'Gallery',
    },
    app: {
      language: 'Language',
      productCode: 'Product code:',
      serialNumber: 'Serial number:',
      status: 'Status',
      nextPmDueDate: 'Next PM due date',
      lastServiced: 'Last serviced',
      requestService: 'Request service',
      missingPublicId: 'Missing public id.',
      missingPublicIdHintPrefix: 'Open a URL like',
      missingPublicIdHintMiddle: ', or for local dev add',
      missingPublicIdHintSuffix: 'to load the same JSON as production.',
      loadingCertificate: 'Loading certificate...',
      couldNotLoadCertificate: 'Could not load certificate',
      unexpectedResponseShape: 'Unexpected response shape.',
      requestFailed: 'Request failed',
      unknownError: 'Unknown error',
    },
    modal: {
      title: 'Request service',
      close: 'Close',
      success: 'Your request was sent. We will get back to you shortly.',
      intro: 'Submit a support request for this equipment (ContactForm - New Issue).',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phoneOptional: 'Phone (optional)',
      companyOptional: 'Company (optional)',
      companyRegNoOptional: 'Company registration no. (optional)',
      details: 'Details',
      cancel: 'Cancel',
      sendRequest: 'Send request',
      sending: 'Sending...',
      requiredError: 'Please enter first name, last name, and email.',
      defaultCommentSuffix: 'Service request',
    },
    chat: {
      title: 'Quick help with this device',
      tagline: 'Ask a question or choose a common issue:',
      suggestionsAria: 'Suggested questions',
      composerPlaceholder: 'Ask a question or choose a common issue above...',
      uploadTitle: 'Upload PDF',
      uploadAria: 'Upload PDF',
      sendAria: 'Send',
      voiceUnavailableAria: 'Voice (not available)',
      footerSupport: 'If you still need help, request service or call support.',
      noReplyFromServer: 'No reply from server.',
      missingItemId: 'Missing device item id on this certificate',
      genericError: 'Sorry, something went wrong:',
      uploadIndexedPrefix: 'Indexed',
      uploadIndexedSuffix: 'chunks). You can ask questions about it now.',
      uploadFailed: 'Upload failed:',
      fallbackText:
        "I'm not fully sure about that yet, but you can request service and our team will help you.",
      fallbackButton: 'Request service',
    },
  },
  cs: {
    tabs: {
      overview: 'Přehled',
      serviceHistory: 'Servisní historie',
      documents: 'Dokumenty',
      gallery: 'Galerie',
    },
    app: {
      language: 'Jazyk',
      productCode: 'Kód produktu:',
      serialNumber: 'Sériové číslo:',
      status: 'Stav',
      nextPmDueDate: 'Termín příští PM',
      lastServiced: 'Poslední servis',
      requestService: 'Vyžádat servis',
      missingPublicId: 'Chybí veřejné ID.',
      missingPublicIdHintPrefix: 'Otevřete URL jako',
      missingPublicIdHintMiddle: 'nebo pro lokální vývoj přidejte',
      missingPublicIdHintSuffix: 'pro načtení stejného JSONu jako v produkci.',
      loadingCertificate: 'Načítám certifikát...',
      couldNotLoadCertificate: 'Nepodařilo se načíst certifikát',
      unexpectedResponseShape: 'Neočekávaný formát odpovědi.',
      requestFailed: 'Požadavek selhal',
      unknownError: 'Neznámá chyba',
    },
    modal: {
      title: 'Vyžádat servis',
      close: 'Zavřít',
      success: 'Váš požadavek byl odeslán. Brzy se vám ozveme.',
      intro: 'Odešlete servisní požadavek pro toto zařízení (ContactForm - New Issue).',
      firstName: 'Jméno',
      lastName: 'Příjmení',
      email: 'E-mail',
      phoneOptional: 'Telefon (volitelné)',
      companyOptional: 'Společnost (volitelné)',
      companyRegNoOptional: 'IČO (volitelné)',
      details: 'Podrobnosti',
      cancel: 'Zrušit',
      sendRequest: 'Odeslat požadavek',
      sending: 'Odesílám...',
      requiredError: 'Vyplňte prosím jméno, příjmení a e-mail.',
      defaultCommentSuffix: 'Servisní požadavek',
    },
    chat: {
      title: 'Rychlá pomoc s tímto zařízením',
      tagline: 'Zeptejte se nebo vyberte častý problém:',
      suggestionsAria: 'Navržené otázky',
      composerPlaceholder: 'Zeptejte se nebo vyberte častý problém výše...',
      uploadTitle: 'Nahrát PDF',
      uploadAria: 'Nahrát PDF',
      sendAria: 'Odeslat',
      voiceUnavailableAria: 'Hlas (není dostupné)',
      footerSupport: 'Pokud stále potřebujete pomoc, vyžádejte servis nebo zavolejte podporu.',
      noReplyFromServer: 'Server nevrátil odpověď.',
      missingItemId: 'V certifikátu chybí ID zařízení',
      genericError: 'Omlouváme se, došlo k chybě:',
      uploadIndexedPrefix: 'Zaindexováno',
      uploadIndexedSuffix: 'chunků). Teď se na to můžete ptát.',
      uploadFailed: 'Nahrání selhalo:',
      fallbackText:
        'Tímto si zatím nejsem úplně jistý, ale můžete vyžádat servis a náš tým vám pomůže.',
      fallbackButton: 'Vyžádat servis',
    },
  },
  de: {
    tabs: {
      overview: 'Übersicht',
      serviceHistory: 'Serviceverlauf',
      documents: 'Dokumente',
      gallery: 'Galerie',
    },
    app: {
      language: 'Sprache',
      productCode: 'Produktcode:',
      serialNumber: 'Seriennummer:',
      status: 'Status',
      nextPmDueDate: 'Nächstes PM-Fälligkeitsdatum',
      lastServiced: 'Zuletzt gewartet',
      requestService: 'Service anfordern',
      missingPublicId: 'Öffentliche ID fehlt.',
      missingPublicIdHintPrefix: 'Öffnen Sie eine URL wie',
      missingPublicIdHintMiddle: 'oder fügen Sie für lokale Entwicklung',
      missingPublicIdHintSuffix: 'hinzu, um dieselbe JSON wie in Produktion zu laden.',
      loadingCertificate: 'Zertifikat wird geladen...',
      couldNotLoadCertificate: 'Zertifikat konnte nicht geladen werden',
      unexpectedResponseShape: 'Unerwartetes Antwortformat.',
      requestFailed: 'Anfrage fehlgeschlagen',
      unknownError: 'Unbekannter Fehler',
    },
    modal: {
      title: 'Service anfordern',
      close: 'Schließen',
      success: 'Ihre Anfrage wurde gesendet. Wir melden uns in Kürze bei Ihnen.',
      intro: 'Senden Sie eine Supportanfrage für dieses Gerät (ContactForm - New Issue).',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phoneOptional: 'Telefon (optional)',
      companyOptional: 'Unternehmen (optional)',
      companyRegNoOptional: 'Handelsregisternr. (optional)',
      details: 'Details',
      cancel: 'Abbrechen',
      sendRequest: 'Anfrage senden',
      sending: 'Senden...',
      requiredError: 'Bitte Vorname, Nachname und E-Mail eingeben.',
      defaultCommentSuffix: 'Serviceanfrage',
    },
    chat: {
      title: 'Schnelle Hilfe zu diesem Gerät',
      tagline: 'Stellen Sie eine Frage oder wählen Sie ein häufiges Problem:',
      suggestionsAria: 'Vorgeschlagene Fragen',
      composerPlaceholder: 'Stellen Sie eine Frage oder wählen Sie oben ein häufiges Problem...',
      uploadTitle: 'PDF hochladen',
      uploadAria: 'PDF hochladen',
      sendAria: 'Senden',
      voiceUnavailableAria: 'Sprache (nicht verfügbar)',
      footerSupport:
        'Wenn Sie weiterhin Hilfe benötigen, fordern Sie Service an oder rufen Sie den Support an.',
      noReplyFromServer: 'Keine Antwort vom Server.',
      missingItemId: 'Geräte-Item-ID fehlt in diesem Zertifikat',
      genericError: 'Entschuldigung, etwas ist schiefgelaufen:',
      uploadIndexedPrefix: 'Indiziert',
      uploadIndexedSuffix: 'Chunks). Sie können jetzt Fragen dazu stellen.',
      uploadFailed: 'Upload fehlgeschlagen:',
      fallbackText:
        'Ich bin mir dabei noch nicht ganz sicher, aber Sie können Service anfordern und unser Team hilft Ihnen weiter.',
      fallbackButton: 'Service anfordern',
    },
  },
};

export function detectLocale() {
  if (typeof navigator === 'undefined') return 'en';
  const candidates = Array.isArray(navigator.languages)
    ? navigator.languages
    : [navigator.language];
  for (const candidate of candidates) {
    const base = String(candidate || '').toLowerCase().split('-')[0];
    if (SUPPORTED_LOCALES.includes(base)) return base;
  }
  return 'en';
}

export function getTranslator(locale) {
  const normalized = SUPPORTED_LOCALES.includes(locale) ? locale : 'en';
  return function t(path) {
    const source = TRANSLATIONS[normalized] || TRANSLATIONS.en;
    const fallback = TRANSLATIONS.en;
    const keys = String(path || '').split('.');
    let value = source;
    for (const key of keys) value = value?.[key];
    if (typeof value === 'string') return value;
    let fallbackValue = fallback;
    for (const key of keys) fallbackValue = fallbackValue?.[key];
    return typeof fallbackValue === 'string' ? fallbackValue : path;
  };
}
